/* eslint-disable */
export default {
  unknown: 'Desconhecido',
  anonymous: 'Anónimo',
  activeCalls: 'Todas as chamadas',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
